export default __webpack_public_path__ + "static/media/b2.729f4967.jpeg";